<div class="or-p-24-px">
  <div class="or-head-md or-mb-8-px">Zgłoś profil</div>
  <div class="or-text-md or-color-secondary-2 or-mb-16-px">
    Opisz, co jest nie tak z tym profilem. Zgłoszenie trafi do naszego zespołu.
  </div>

  <form [formGroup]="reportForm">
    <ion-textarea
      formControlName="message"
      class="textarea-style outline-none"
      maxlength="1000"
      rows="5"
      auto-grow="true"></ion-textarea>
  </form>

  @if (isMessageTooShort) {
    <div class="or-text-sm or-color-red or-mt-4-px">Minimalna ilość znaków to 10</div>
  }

  <div class="or-d-flex or-mt-24-px">
    <button (click)="close()" class="button-secondary-style or-h-48-px or-w-100-pc or-head-md or-mr-12-px">
      Anuluj
    </button>
    <button
      [disabled]="!reportForm.valid"
      (click)="submit()"
      class="button-primary-style or-color-white or-h-48-px or-w-100-pc or-head-md"
      [ngClass]="{ 'disabled-button': !reportForm.valid }">
      Wyślij zgłoszenie
    </button>
  </div>
</div>
